import {
  useFxWorkspaceContext,
  type FxDraftLayer,
} from '@mobile-mapping/providers';
import { t } from '@trimble/i18n';
import { BtnClasses, IconButton } from '@tcweb/connect-ui';
import { Component, JSX, createMemo } from 'solid-js';

import {
  breaklineTypeNodeId,
  draftLayerNodeId,
} from '../selections/tree/fx-workspace-tree-nodes';

export interface FxDraftLayerRowProps {
  readonly workspaceId: string;
  readonly layer: FxDraftLayer;
}

export const FxDraftLayerRow: Component<FxDraftLayerRowProps> = (
  props
): JSX.Element => {
  const fxWorkspace = useFxWorkspaceContext();

  const nodeId = createMemo(() =>
    props.layer.kind === 'breakline' && props.layer.breaklineType !== undefined
      ? breaklineTypeNodeId(props.workspaceId, props.layer.breaklineType)
      : draftLayerNodeId(props.workspaceId, props.layer.layerId)
  );

  const isVisible = createMemo(() =>
    fxWorkspace.isExtractedFeatureNodeVisible(nodeId())
  );

  const handleToggleVisibility = (): void => {
    fxWorkspace.toggleExtractedFeatureNodeVisibility(nodeId());
  };

  return (
    <div
      class="flex items-center gap-2 py-1 pl-1 pr-2"
      data-testid={`draft-layer-${props.layer.layerId}`}
    >
      <IconButton
        color={BtnClasses.TERTIARY}
        icon={
          isVisible() ? 'tc-icon-eye-visibility' : 'tc-icon-eye-visibility-off'
        }
        size="icon-medium"
        data-testid={`draft-layer-visibility-${props.layer.layerId}`}
        title={
          isVisible()
            ? t('mobileMapping.fxWorkspace.draftLayers.hide')
            : t('mobileMapping.fxWorkspace.draftLayers.show')
        }
        clicked={handleToggleVisibility}
      />
      <span class="truncate text-sm">{props.layer.label}</span>
    </div>
  );
};
